import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Landing from './Landing.jsx';

import {loadUniverse} from '../../components/UniverseLoader/actions.js';

class LandingUniverse extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    helmet: PropTypes.object.isRequired,
    universeCode: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
    helmet: {title: '', description: ''},
    universeCode: null,
  }

  componentDidMount() {
    this.loadUniverse(this.props.universes.filter((universe) => universe.code === this.props.universeCode)[0]);
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevProps.universeCode !== this.props.universeCode) {
      this.loadUniverse(
        this.props.universes.filter((universe) => universe.code === this.props.universeCode)[0]
      );
    }
  }

  loadUniverse = (universe) => {
    if (universe !== null && (this.props.currentUniverse === null || (universe.id !== this.props.currentUniverse.id))) {
      this.props.loadUniverse(universe);
    }
  }

  render() {
    return <Landing {...this.props}/>;
  }
}

export default connect(
  state => ({
    currentUniverse: state.universe.currentUniverse,
    universes: state.universe.universes,
  }),
  dispatch => ({
    loadUniverse: (universe) => dispatch(loadUniverse(universe))
  }),
)(LandingUniverse);
